module.exports = __webpack_public_path__ + "54bd28fe8f6cb4e9418e3ed6fac9584a.png";